{
 "en": {
  "sub_account_management": "Account Management",
  "sub_aerospace_defense": "Aerospace & Defense",
  "sub_ai_in_marketing": "AI in Marketing",
  "sub_architecture": "Software Architecture",
  "sub_automotive": "Automotive",
  "sub_b2b_sales": "B2B Sales",
  "sub_backend": "Backend Development",
  "sub_bootstrapping": "Bootstrapping",
  "sub_brand_design": "Brand & Visual Design",
  "sub_brand_marketing": "Brand Marketing",
  "sub_business_development": "Business Development",
  "sub_career_development": "Career Development",
  "sub_communication_skills": "Communication Skills",
  "sub_compensation": "Compensation & Benefits",
  "sub_consumer_retail": "Consumer & Retail",
  "sub_content_marketing": "Content Marketing",
  "sub_corporate_finance": "Corporate Finance",
  "sub_data_analytics": "Data Analytics",
  "sub_data_engineering": "Data Engineering",
  "sub_decision_making": "Decision Making",
  "sub_design_systems": "Design Systems",
  "sub_devops_cloud": "DevOps & Cloud",
  "sub_energy": "Energy",
  "sub_financial_services": "Financial Services",
  "sub_fintech": "Fintech",
  "sub_frontend": "Frontend Development",
  "sub_fundraising_vc": "Fundraising & VC",
  "sub_generative_ai": "Generative AI (LLMs)",
  "sub_go_to_market": "Go-to-Market",
  "sub_government_public": "Government & Policy",
  "sub_growth_marketing": "Growth Marketing",
  "sub_healthcare_lifesciences": "Healthcare & Life Sciences",
  "sub_industrial_manufacturing": "Industrial & Manufacturing",
  "sub_infrastructure_construction": "Infrastructure & Construction",
  "sub_insurance": "Insurance",
  "sub_investing_markets": "Investing & Markets",
  "sub_learning_development": "Learning & Development",
  "sub_machine_learning": "Machine Learning",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "Mobile Development",
  "sub_networking": "Networking",
  "sub_org_culture": "Company Culture",
  "sub_org_strategy": "Org & Strategy",
  "sub_people_management": "People Management",
  "sub_performance_marketing": "Performance Marketing",
  "sub_personal_finance": "Personal Finance",
  "sub_process_optimization": "Process Optimization",
  "sub_product_analytics": "Product Analytics",
  "sub_product_design": "Product Design",
  "sub_product_discovery": "Product Discovery & Research",
  "sub_product_led_growth": "Product-Led Growth",
  "sub_product_strategy": "Product Strategy",
  "sub_productivity": "Productivity",
  "sub_project_management": "Project Management",
  "sub_remote_teams": "Remote & Hybrid Teams",
  "sub_roadmapping": "Roadmapping & Prioritization",
  "sub_sales_ops": "Sales Operations",
  "sub_security": "Security",
  "sub_seo_sem": "SEO & SEM",
  "sub_social_media_marketing": "Social Media Marketing",
  "sub_solopreneurship": "Solopreneurship",
  "sub_startup_building": "Startup Building",
  "sub_supply_chain": "Supply Chain",
  "sub_talent_acquisition": "Talent Acquisition",
  "sub_tech_media_telecom": "Tech, Media & Telecom",
  "sub_transport_logistics": "Transport & Logistics",
  "sub_ui_design": "UI Design",
  "sub_ux_research": "UX Research",
  "sub_wellbeing": "Work-Life Balance",
  "cat_empty_title": "No content in this topic yet",
  "cat_business": "Business",
  "cat_finance": "Finance",
  "cat_data_ai": "Data & AI",
  "cat_leadership": "Leadership",
  "cat_growth": "Career Growth",
  "cat_design": "Design & UX",
  "cat_people": "People & Culture",
  "cat_entrepreneurship": "Entrepreneurship",
  "cat_operations": "Operations",
  "cat_engineering": "Software & Engineering",
  "cat_marketing": "Marketing",
  "cat_product": "Product Management",
  "cat_sales": "Sales & BD"
 },
 "es": {
  "sub_account_management": "Gestión de cuentas",
  "sub_aerospace_defense": "Aeroespacial y defensa",
  "sub_ai_in_marketing": "IA en marketing",
  "sub_architecture": "Arquitectura de software",
  "sub_automotive": "Automoción",
  "sub_b2b_sales": "Ventas B2B",
  "sub_backend": "Desarrollo backend",
  "sub_bootstrapping": "Bootstrapping",
  "sub_brand_design": "Marca y diseño visual",
  "sub_brand_marketing": "Marketing de marca",
  "sub_business_development": "Desarrollo de negocio",
  "sub_career_development": "Desarrollo profesional",
  "sub_communication_skills": "Habilidades de comunicación",
  "sub_compensation": "Retribución y beneficios",
  "sub_consumer_retail": "Consumo y retail",
  "sub_content_marketing": "Marketing de contenidos",
  "sub_corporate_finance": "Finanzas corporativas",
  "sub_data_analytics": "Analítica de datos",
  "sub_data_engineering": "Ingeniería de datos",
  "sub_decision_making": "Toma de decisiones",
  "sub_design_systems": "Sistemas de diseño",
  "sub_devops_cloud": "DevOps y cloud",
  "sub_energy": "Energía",
  "sub_financial_services": "Servicios financieros",
  "sub_fintech": "Fintech",
  "sub_frontend": "Desarrollo frontend",
  "sub_fundraising_vc": "Financiación y capital riesgo",
  "sub_generative_ai": "IA generativa (LLM)",
  "sub_go_to_market": "Go-to-market",
  "sub_government_public": "Gobierno y políticas",
  "sub_growth_marketing": "Growth marketing",
  "sub_healthcare_lifesciences": "Salud y ciencias de la vida",
  "sub_industrial_manufacturing": "Industria y manufactura",
  "sub_infrastructure_construction": "Infraestructura y construcción",
  "sub_insurance": "Seguros",
  "sub_investing_markets": "Inversión y mercados",
  "sub_learning_development": "Formación y desarrollo",
  "sub_machine_learning": "Machine learning",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "Desarrollo móvil",
  "sub_networking": "Networking",
  "sub_org_culture": "Cultura de empresa",
  "sub_org_strategy": "Organización y estrategia",
  "sub_people_management": "Gestión de equipos",
  "sub_performance_marketing": "Marketing de resultados",
  "sub_personal_finance": "Finanzas personales",
  "sub_process_optimization": "Optimización de procesos",
  "sub_product_analytics": "Analítica de producto",
  "sub_product_design": "Diseño de producto",
  "sub_product_discovery": "Descubrimiento e investigación",
  "sub_product_led_growth": "Product-led growth",
  "sub_product_strategy": "Estrategia de producto",
  "sub_productivity": "Productividad",
  "sub_project_management": "Gestión de proyectos",
  "sub_remote_teams": "Equipos remotos e híbridos",
  "sub_roadmapping": "Hoja de ruta y priorización",
  "sub_sales_ops": "Operaciones de ventas",
  "sub_security": "Seguridad",
  "sub_seo_sem": "SEO y SEM",
  "sub_social_media_marketing": "Marketing en redes sociales",
  "sub_solopreneurship": "Emprendimiento en solitario",
  "sub_startup_building": "Crear una startup",
  "sub_supply_chain": "Cadena de suministro",
  "sub_talent_acquisition": "Selección de talento",
  "sub_tech_media_telecom": "Tecnología, medios y telecom",
  "sub_transport_logistics": "Transporte y logística",
  "sub_ui_design": "Diseño de UI",
  "sub_ux_research": "Investigación UX",
  "sub_wellbeing": "Equilibrio vida-trabajo",
  "cat_empty_title": "Todavía no hay contenido en este tema",
  "cat_business": "Negocios",
  "cat_finance": "Finanzas",
  "cat_data_ai": "Datos e IA",
  "cat_leadership": "Liderazgo",
  "cat_growth": "Desarrollo profesional",
  "cat_design": "Diseño y UX",
  "cat_people": "Personas y cultura",
  "cat_entrepreneurship": "Emprendimiento",
  "cat_operations": "Operaciones",
  "cat_engineering": "Software e ingeniería",
  "cat_marketing": "Marketing",
  "cat_product": "Gestión de producto",
  "cat_sales": "Ventas y desarrollo"
 },
 "fr": {
  "sub_account_management": "Gestion de comptes",
  "sub_aerospace_defense": "Aérospatial et défense",
  "sub_ai_in_marketing": "IA en marketing",
  "sub_architecture": "Architecture logicielle",
  "sub_automotive": "Automobile",
  "sub_b2b_sales": "Ventes B2B",
  "sub_backend": "Développement backend",
  "sub_bootstrapping": "Bootstrapping",
  "sub_brand_design": "Marque et design visuel",
  "sub_brand_marketing": "Marketing de marque",
  "sub_business_development": "Développement commercial",
  "sub_career_development": "Développement de carrière",
  "sub_communication_skills": "Compétences en communication",
  "sub_compensation": "Rémunération et avantages",
  "sub_consumer_retail": "Grande consommation et retail",
  "sub_content_marketing": "Marketing de contenu",
  "sub_corporate_finance": "Finance d’entreprise",
  "sub_data_analytics": "Analyse de données",
  "sub_data_engineering": "Ingénierie des données",
  "sub_decision_making": "Prise de décision",
  "sub_design_systems": "Design systems",
  "sub_devops_cloud": "DevOps et cloud",
  "sub_energy": "Énergie",
  "sub_financial_services": "Services financiers",
  "sub_fintech": "Fintech",
  "sub_frontend": "Développement frontend",
  "sub_fundraising_vc": "Levée de fonds et VC",
  "sub_generative_ai": "IA générative (LLM)",
  "sub_go_to_market": "Go-to-market",
  "sub_government_public": "Secteur public et politiques",
  "sub_growth_marketing": "Growth marketing",
  "sub_healthcare_lifesciences": "Santé et sciences de la vie",
  "sub_industrial_manufacturing": "Industrie et production",
  "sub_infrastructure_construction": "Infrastructure et construction",
  "sub_insurance": "Assurance",
  "sub_investing_markets": "Investissement et marchés",
  "sub_learning_development": "Formation et développement",
  "sub_machine_learning": "Machine learning",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "Développement mobile",
  "sub_networking": "Réseautage",
  "sub_org_culture": "Culture d’entreprise",
  "sub_org_strategy": "Organisation et stratégie",
  "sub_people_management": "Management d’équipe",
  "sub_performance_marketing": "Marketing à la performance",
  "sub_personal_finance": "Finances personnelles",
  "sub_process_optimization": "Optimisation des processus",
  "sub_product_analytics": "Analytique produit",
  "sub_product_design": "Design produit",
  "sub_product_discovery": "Discovery et recherche produit",
  "sub_product_led_growth": "Product-led growth",
  "sub_product_strategy": "Stratégie produit",
  "sub_productivity": "Productivité",
  "sub_project_management": "Gestion de projet",
  "sub_remote_teams": "Équipes à distance et hybrides",
  "sub_roadmapping": "Roadmap et priorisation",
  "sub_sales_ops": "Sales operations",
  "sub_security": "Sécurité",
  "sub_seo_sem": "SEO et SEM",
  "sub_social_media_marketing": "Marketing des réseaux sociaux",
  "sub_solopreneurship": "Entrepreneuriat solo",
  "sub_startup_building": "Créer une startup",
  "sub_supply_chain": "Chaîne d’approvisionnement",
  "sub_talent_acquisition": "Recrutement",
  "sub_tech_media_telecom": "Tech, médias et télécoms",
  "sub_transport_logistics": "Transport et logistique",
  "sub_ui_design": "Design UI",
  "sub_ux_research": "Recherche UX",
  "sub_wellbeing": "Équilibre vie pro-perso",
  "cat_empty_title": "Aucun contenu dans ce sujet pour l’instant",
  "cat_business": "Business",
  "cat_finance": "Finance",
  "cat_data_ai": "Data et IA",
  "cat_leadership": "Leadership",
  "cat_growth": "Évolution de carrière",
  "cat_design": "Design et UX",
  "cat_people": "RH et culture",
  "cat_entrepreneurship": "Entrepreneuriat",
  "cat_operations": "Opérations",
  "cat_engineering": "Logiciel et ingénierie",
  "cat_marketing": "Marketing",
  "cat_product": "Gestion de produit",
  "cat_sales": "Ventes et développement"
 },
 "it": {
  "sub_account_management": "Gestione clienti",
  "sub_aerospace_defense": "Aerospaziale e difesa",
  "sub_ai_in_marketing": "IA nel marketing",
  "sub_architecture": "Architettura software",
  "sub_automotive": "Automotive",
  "sub_b2b_sales": "Vendite B2B",
  "sub_backend": "Sviluppo backend",
  "sub_bootstrapping": "Bootstrapping",
  "sub_brand_design": "Brand e design visivo",
  "sub_brand_marketing": "Brand marketing",
  "sub_business_development": "Sviluppo commerciale",
  "sub_career_development": "Sviluppo di carriera",
  "sub_communication_skills": "Capacità comunicative",
  "sub_compensation": "Retribuzione e benefit",
  "sub_consumer_retail": "Consumo e retail",
  "sub_content_marketing": "Content marketing",
  "sub_corporate_finance": "Finanza aziendale",
  "sub_data_analytics": "Analisi dei dati",
  "sub_data_engineering": "Data engineering",
  "sub_decision_making": "Processo decisionale",
  "sub_design_systems": "Design system",
  "sub_devops_cloud": "DevOps e cloud",
  "sub_energy": "Energia",
  "sub_financial_services": "Servizi finanziari",
  "sub_fintech": "Fintech",
  "sub_frontend": "Sviluppo frontend",
  "sub_fundraising_vc": "Raccolta fondi e VC",
  "sub_generative_ai": "IA generativa (LLM)",
  "sub_go_to_market": "Go-to-market",
  "sub_government_public": "Settore pubblico e policy",
  "sub_growth_marketing": "Growth marketing",
  "sub_healthcare_lifesciences": "Sanità e scienze della vita",
  "sub_industrial_manufacturing": "Industria e produzione",
  "sub_infrastructure_construction": "Infrastrutture e costruzioni",
  "sub_insurance": "Assicurazioni",
  "sub_investing_markets": "Investimenti e mercati",
  "sub_learning_development": "Formazione e sviluppo",
  "sub_machine_learning": "Machine learning",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "Sviluppo mobile",
  "sub_networking": "Networking",
  "sub_org_culture": "Cultura aziendale",
  "sub_org_strategy": "Organizzazione e strategia",
  "sub_people_management": "Gestione delle persone",
  "sub_performance_marketing": "Performance marketing",
  "sub_personal_finance": "Finanza personale",
  "sub_process_optimization": "Ottimizzazione dei processi",
  "sub_product_analytics": "Product analytics",
  "sub_product_design": "Design di prodotto",
  "sub_product_discovery": "Discovery e ricerca",
  "sub_product_led_growth": "Product-led growth",
  "sub_product_strategy": "Strategia di prodotto",
  "sub_productivity": "Produttività",
  "sub_project_management": "Project management",
  "sub_remote_teams": "Team remoti e ibridi",
  "sub_roadmapping": "Roadmap e prioritizzazione",
  "sub_sales_ops": "Sales operations",
  "sub_security": "Sicurezza",
  "sub_seo_sem": "SEO e SEM",
  "sub_social_media_marketing": "Social media marketing",
  "sub_solopreneurship": "Solopreneurship",
  "sub_startup_building": "Costruire una startup",
  "sub_supply_chain": "Supply chain",
  "sub_talent_acquisition": "Talent acquisition",
  "sub_tech_media_telecom": "Tech, media e telecom",
  "sub_transport_logistics": "Trasporti e logistica",
  "sub_ui_design": "Design UI",
  "sub_ux_research": "Ricerca UX",
  "sub_wellbeing": "Equilibrio vita-lavoro",
  "cat_empty_title": "Ancora nessun contenuto in questo argomento",
  "cat_business": "Business",
  "cat_finance": "Finanza",
  "cat_data_ai": "Dati e IA",
  "cat_leadership": "Leadership",
  "cat_growth": "Crescita professionale",
  "cat_design": "Design e UX",
  "cat_people": "Persone e cultura",
  "cat_entrepreneurship": "Imprenditoria",
  "cat_operations": "Operations",
  "cat_engineering": "Software e ingegneria",
  "cat_marketing": "Marketing",
  "cat_product": "Product management",
  "cat_sales": "Vendite e sviluppo"
 },
 "de": {
  "sub_account_management": "Kundenbetreuung",
  "sub_aerospace_defense": "Luft- und Raumfahrt",
  "sub_ai_in_marketing": "KI im Marketing",
  "sub_architecture": "Softwarearchitektur",
  "sub_automotive": "Automobil",
  "sub_b2b_sales": "B2B-Vertrieb",
  "sub_backend": "Backend-Entwicklung",
  "sub_bootstrapping": "Bootstrapping",
  "sub_brand_design": "Marken- & Visual Design",
  "sub_brand_marketing": "Markenmarketing",
  "sub_business_development": "Geschäftsentwicklung",
  "sub_career_development": "Karriereentwicklung",
  "sub_communication_skills": "Kommunikationsfähigkeiten",
  "sub_compensation": "Vergütung & Benefits",
  "sub_consumer_retail": "Konsum & Handel",
  "sub_content_marketing": "Content-Marketing",
  "sub_corporate_finance": "Unternehmensfinanzen",
  "sub_data_analytics": "Datenanalyse",
  "sub_data_engineering": "Data Engineering",
  "sub_decision_making": "Entscheidungsfindung",
  "sub_design_systems": "Design-Systeme",
  "sub_devops_cloud": "DevOps & Cloud",
  "sub_energy": "Energie",
  "sub_financial_services": "Finanzdienstleistungen",
  "sub_fintech": "Fintech",
  "sub_frontend": "Frontend-Entwicklung",
  "sub_fundraising_vc": "Fundraising & VC",
  "sub_generative_ai": "Generative KI (LLMs)",
  "sub_go_to_market": "Go-to-Market",
  "sub_government_public": "Staat & Politik",
  "sub_growth_marketing": "Growth Marketing",
  "sub_healthcare_lifesciences": "Gesundheit & Life Sciences",
  "sub_industrial_manufacturing": "Industrie & Fertigung",
  "sub_infrastructure_construction": "Infrastruktur & Bau",
  "sub_insurance": "Versicherung",
  "sub_investing_markets": "Investieren & Märkte",
  "sub_learning_development": "Lernen & Entwicklung",
  "sub_machine_learning": "Maschinelles Lernen",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "Mobile-Entwicklung",
  "sub_networking": "Networking",
  "sub_org_culture": "Unternehmenskultur",
  "sub_org_strategy": "Organisation & Strategie",
  "sub_people_management": "Mitarbeiterführung",
  "sub_performance_marketing": "Performance-Marketing",
  "sub_personal_finance": "Persönliche Finanzen",
  "sub_process_optimization": "Prozessoptimierung",
  "sub_product_analytics": "Produktanalytik",
  "sub_product_design": "Produktdesign",
  "sub_product_discovery": "Product Discovery & Research",
  "sub_product_led_growth": "Product-Led Growth",
  "sub_product_strategy": "Produktstrategie",
  "sub_productivity": "Produktivität",
  "sub_project_management": "Projektmanagement",
  "sub_remote_teams": "Remote- & Hybridteams",
  "sub_roadmapping": "Roadmapping & Priorisierung",
  "sub_sales_ops": "Sales Operations",
  "sub_security": "Sicherheit",
  "sub_seo_sem": "SEO & SEM",
  "sub_social_media_marketing": "Social-Media-Marketing",
  "sub_solopreneurship": "Solopreneurship",
  "sub_startup_building": "Startup gründen",
  "sub_supply_chain": "Lieferkette",
  "sub_talent_acquisition": "Recruiting",
  "sub_tech_media_telecom": "Tech, Medien & Telekom",
  "sub_transport_logistics": "Transport & Logistik",
  "sub_ui_design": "UI-Design",
  "sub_ux_research": "UX-Research",
  "sub_wellbeing": "Work-Life-Balance",
  "cat_empty_title": "Noch keine Inhalte zu diesem Thema",
  "cat_business": "Wirtschaft",
  "cat_finance": "Finanzen",
  "cat_data_ai": "Daten & KI",
  "cat_leadership": "Führung",
  "cat_growth": "Karriere & Entwicklung",
  "cat_design": "Design & UX",
  "cat_people": "People & Kultur",
  "cat_entrepreneurship": "Gründung",
  "cat_operations": "Operations",
  "cat_engineering": "Software & Technik",
  "cat_marketing": "Marketing",
  "cat_product": "Produktmanagement",
  "cat_sales": "Vertrieb & BD"
 },
 "pt": {
  "sub_account_management": "Gestão de contas",
  "sub_aerospace_defense": "Aeroespacial e defesa",
  "sub_ai_in_marketing": "IA no marketing",
  "sub_architecture": "Arquitetura de software",
  "sub_automotive": "Automóvel",
  "sub_b2b_sales": "Vendas B2B",
  "sub_backend": "Desenvolvimento backend",
  "sub_bootstrapping": "Bootstrapping",
  "sub_brand_design": "Marca e design visual",
  "sub_brand_marketing": "Marketing de marca",
  "sub_business_development": "Desenvolvimento de negócio",
  "sub_career_development": "Desenvolvimento de carreira",
  "sub_communication_skills": "Competências de comunicação",
  "sub_compensation": "Remuneração e benefícios",
  "sub_consumer_retail": "Consumo e retalho",
  "sub_content_marketing": "Marketing de conteúdo",
  "sub_corporate_finance": "Finanças corporativas",
  "sub_data_analytics": "Análise de dados",
  "sub_data_engineering": "Engenharia de dados",
  "sub_decision_making": "Tomada de decisão",
  "sub_design_systems": "Sistemas de design",
  "sub_devops_cloud": "DevOps e cloud",
  "sub_energy": "Energia",
  "sub_financial_services": "Serviços financeiros",
  "sub_fintech": "Fintech",
  "sub_frontend": "Desenvolvimento frontend",
  "sub_fundraising_vc": "Financiamento e capital de risco",
  "sub_generative_ai": "IA generativa (LLM)",
  "sub_go_to_market": "Go-to-market",
  "sub_government_public": "Governo e políticas",
  "sub_growth_marketing": "Growth marketing",
  "sub_healthcare_lifesciences": "Saúde e ciências da vida",
  "sub_industrial_manufacturing": "Indústria e produção",
  "sub_infrastructure_construction": "Infraestrutura e construção",
  "sub_insurance": "Seguros",
  "sub_investing_markets": "Investimento e mercados",
  "sub_learning_development": "Formação e desenvolvimento",
  "sub_machine_learning": "Machine learning",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "Desenvolvimento móvel",
  "sub_networking": "Networking",
  "sub_org_culture": "Cultura de empresa",
  "sub_org_strategy": "Organização e estratégia",
  "sub_people_management": "Gestão de equipas",
  "sub_performance_marketing": "Marketing de performance",
  "sub_personal_finance": "Finanças pessoais",
  "sub_process_optimization": "Otimização de processos",
  "sub_product_analytics": "Analítica de produto",
  "sub_product_design": "Design de produto",
  "sub_product_discovery": "Descoberta e pesquisa de produto",
  "sub_product_led_growth": "Product-led growth",
  "sub_product_strategy": "Estratégia de produto",
  "sub_productivity": "Produtividade",
  "sub_project_management": "Gestão de projetos",
  "sub_remote_teams": "Equipas remotas e híbridas",
  "sub_roadmapping": "Roadmap e priorização",
  "sub_sales_ops": "Operações de vendas",
  "sub_security": "Segurança",
  "sub_seo_sem": "SEO e SEM",
  "sub_social_media_marketing": "Marketing em redes sociais",
  "sub_solopreneurship": "Empreendedorismo a solo",
  "sub_startup_building": "Criar uma startup",
  "sub_supply_chain": "Cadeia de abastecimento",
  "sub_talent_acquisition": "Recrutamento",
  "sub_tech_media_telecom": "Tecnologia, media e telecom",
  "sub_transport_logistics": "Transporte e logística",
  "sub_ui_design": "Design de UI",
  "sub_ux_research": "Pesquisa UX",
  "sub_wellbeing": "Equilíbrio vida-trabalho",
  "cat_business": "Negócios",
  "cat_finance": "Finanças",
  "cat_data_ai": "Dados & AI",
  "cat_leadership": "Liderança",
  "cat_growth": "Crescimento Profissional",
  "cat_design": "Design & UX",
  "cat_people": "Pessoas & Cultura",
  "cat_entrepreneurship": "Empreendedorismo",
  "cat_operations": "Operações",
  "cat_engineering": "Software & Engenharia",
  "cat_marketing": "Marketing",
  "cat_product": "Gestão de Produto",
  "cat_sales": "Vendas & BD",
  "cat_empty_title": "Ainda não há conteúdo neste tópico"
 },
 "ja": {
  "sub_account_management": "アカウント管理",
  "sub_aerospace_defense": "航空宇宙・防衛",
  "sub_ai_in_marketing": "マーケティングのAI",
  "sub_architecture": "ソフトウェア設計",
  "sub_automotive": "自動車",
  "sub_b2b_sales": "B2B営業",
  "sub_backend": "バックエンド開発",
  "sub_bootstrapping": "ブートストラップ経営",
  "sub_brand_design": "ブランド・ビジュアル設計",
  "sub_brand_marketing": "ブランドマーケティング",
  "sub_business_development": "事業開発",
  "sub_career_development": "キャリア開発",
  "sub_communication_skills": "コミュニケーション力",
  "sub_compensation": "報酬・福利厚生",
  "sub_consumer_retail": "消費財・小売",
  "sub_content_marketing": "コンテンツマーケティング",
  "sub_corporate_finance": "コーポレートファイナンス",
  "sub_data_analytics": "データ分析",
  "sub_data_engineering": "データエンジニアリング",
  "sub_decision_making": "意思決定",
  "sub_design_systems": "デザインシステム",
  "sub_devops_cloud": "DevOps・クラウド",
  "sub_energy": "エネルギー",
  "sub_financial_services": "金融サービス",
  "sub_fintech": "フィンテック",
  "sub_frontend": "フロントエンド開発",
  "sub_fundraising_vc": "資金調達・VC",
  "sub_generative_ai": "生成AI（LLM）",
  "sub_go_to_market": "市場投入戦略",
  "sub_government_public": "行政・政策",
  "sub_growth_marketing": "グロースマーケティング",
  "sub_healthcare_lifesciences": "ヘルスケア・ライフサイエンス",
  "sub_industrial_manufacturing": "産業・製造",
  "sub_infrastructure_construction": "インフラ・建設",
  "sub_insurance": "保険",
  "sub_investing_markets": "投資・市場",
  "sub_learning_development": "学習・育成",
  "sub_machine_learning": "機械学習",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "モバイル開発",
  "sub_networking": "人脈づくり",
  "sub_org_culture": "企業文化",
  "sub_org_strategy": "組織・戦略",
  "sub_people_management": "ピープルマネジメント",
  "sub_performance_marketing": "パフォーマンスマーケティング",
  "sub_personal_finance": "パーソナルファイナンス",
  "sub_process_optimization": "業務プロセス改善",
  "sub_product_analytics": "プロダクト分析",
  "sub_product_design": "プロダクトデザイン",
  "sub_product_discovery": "プロダクトディスカバリー",
  "sub_product_led_growth": "プロダクト主導成長",
  "sub_product_strategy": "プロダクト戦略",
  "sub_productivity": "生産性",
  "sub_project_management": "プロジェクト管理",
  "sub_remote_teams": "リモート・ハイブリッド組織",
  "sub_roadmapping": "ロードマップ・優先順位",
  "sub_sales_ops": "セールスオペレーション",
  "sub_security": "セキュリティ",
  "sub_seo_sem": "SEO・SEM",
  "sub_social_media_marketing": "ソーシャルメディア運用",
  "sub_solopreneurship": "ひとり起業",
  "sub_startup_building": "スタートアップ立ち上げ",
  "sub_supply_chain": "サプライチェーン",
  "sub_talent_acquisition": "採用",
  "sub_tech_media_telecom": "テック・メディア・通信",
  "sub_transport_logistics": "運輸・物流",
  "sub_ui_design": "UIデザイン",
  "sub_ux_research": "UXリサーチ",
  "sub_wellbeing": "ワークライフバランス",
  "cat_business": "ビジネス",
  "cat_finance": "金融",
  "cat_data_ai": "データ & AI",
  "cat_leadership": "リーダーシップ",
  "cat_growth": "キャリア成長",
  "cat_design": "デザイン & UX",
  "cat_people": "人材 & 文化",
  "cat_entrepreneurship": "起業",
  "cat_operations": "オペレーション",
  "cat_engineering": "ソフトウェア & エンジニアリング",
  "cat_marketing": "マーケティング",
  "cat_product": "プロダクトマネジメント",
  "cat_sales": "セールス & BD",
  "cat_empty_title": "このトピックのコンテンツはまだありません"
 },
 "ko": {
  "sub_account_management": "고객 관리",
  "sub_aerospace_defense": "항공우주·방위",
  "sub_ai_in_marketing": "마케팅의 AI",
  "sub_architecture": "소프트웨어 아키텍처",
  "sub_automotive": "자동차",
  "sub_b2b_sales": "B2B 영업",
  "sub_backend": "백엔드 개발",
  "sub_bootstrapping": "부트스트래핑",
  "sub_brand_design": "브랜드·비주얼 디자인",
  "sub_brand_marketing": "브랜드 마케팅",
  "sub_business_development": "사업 개발",
  "sub_career_development": "커리어 개발",
  "sub_communication_skills": "커뮤니케이션 역량",
  "sub_compensation": "보상·복리후생",
  "sub_consumer_retail": "소비재·리테일",
  "sub_content_marketing": "콘텐츠 마케팅",
  "sub_corporate_finance": "기업 재무",
  "sub_data_analytics": "데이터 분석",
  "sub_data_engineering": "데이터 엔지니어링",
  "sub_decision_making": "의사결정",
  "sub_design_systems": "디자인 시스템",
  "sub_devops_cloud": "DevOps·클라우드",
  "sub_energy": "에너지",
  "sub_financial_services": "금융 서비스",
  "sub_fintech": "핀테크",
  "sub_frontend": "프런트엔드 개발",
  "sub_fundraising_vc": "자금 조달·VC",
  "sub_generative_ai": "생성형 AI(LLM)",
  "sub_go_to_market": "시장 진입 전략",
  "sub_government_public": "정부·정책",
  "sub_growth_marketing": "그로스 마케팅",
  "sub_healthcare_lifesciences": "헬스케어·생명과학",
  "sub_industrial_manufacturing": "산업·제조",
  "sub_infrastructure_construction": "인프라·건설",
  "sub_insurance": "보험",
  "sub_investing_markets": "투자·시장",
  "sub_learning_development": "학습·개발",
  "sub_machine_learning": "머신러닝",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "모바일 개발",
  "sub_networking": "네트워킹",
  "sub_org_culture": "조직 문화",
  "sub_org_strategy": "조직·전략",
  "sub_people_management": "팀 관리",
  "sub_performance_marketing": "퍼포먼스 마케팅",
  "sub_personal_finance": "개인 재무",
  "sub_process_optimization": "프로세스 최적화",
  "sub_product_analytics": "프로덕트 애널리틱스",
  "sub_product_design": "제품 디자인",
  "sub_product_discovery": "제품 디스커버리·리서치",
  "sub_product_led_growth": "제품 주도 성장",
  "sub_product_strategy": "제품 전략",
  "sub_productivity": "생산성",
  "sub_project_management": "프로젝트 관리",
  "sub_remote_teams": "원격·하이브리드 팀",
  "sub_roadmapping": "로드맵·우선순위",
  "sub_sales_ops": "세일즈 오퍼레이션",
  "sub_security": "보안",
  "sub_seo_sem": "SEO·SEM",
  "sub_social_media_marketing": "소셜미디어 마케팅",
  "sub_solopreneurship": "1인 창업",
  "sub_startup_building": "스타트업 만들기",
  "sub_supply_chain": "공급망",
  "sub_talent_acquisition": "인재 채용",
  "sub_tech_media_telecom": "테크·미디어·통신",
  "sub_transport_logistics": "운송·물류",
  "sub_ui_design": "UI 디자인",
  "sub_ux_research": "UX 리서치",
  "sub_wellbeing": "일과 삶의 균형",
  "cat_business": "비즈니스",
  "cat_finance": "금융",
  "cat_data_ai": "데이터 & AI",
  "cat_leadership": "리더십",
  "cat_growth": "커리어 성장",
  "cat_design": "디자인 & UX",
  "cat_people": "인사 & 문화",
  "cat_entrepreneurship": "기업가 정신",
  "cat_operations": "운영",
  "cat_engineering": "소프트웨어 & 엔지니어링",
  "cat_marketing": "마케팅",
  "cat_product": "제품 관리",
  "cat_sales": "영업 & BD",
  "cat_empty_title": "이 주제의 콘텐츠가 아직 없습니다"
 },
 "ar": {
  "sub_account_management": "إدارة الحسابات",
  "sub_aerospace_defense": "الطيران والدفاع",
  "sub_ai_in_marketing": "الذكاء الاصطناعي في التسويق",
  "sub_architecture": "معمارية البرمجيات",
  "sub_automotive": "السيارات",
  "sub_b2b_sales": "مبيعات B2B",
  "sub_backend": "تطوير الواجهة الخلفية",
  "sub_bootstrapping": "التمويل الذاتي",
  "sub_brand_design": "تصميم العلامة والهوية",
  "sub_brand_marketing": "تسويق العلامة",
  "sub_business_development": "تطوير الأعمال",
  "sub_career_development": "التطوير المهني",
  "sub_communication_skills": "مهارات التواصل",
  "sub_compensation": "الأجور والمزايا",
  "sub_consumer_retail": "الاستهلاك والتجزئة",
  "sub_content_marketing": "تسويق المحتوى",
  "sub_corporate_finance": "التمويل المؤسسي",
  "sub_data_analytics": "تحليلات البيانات",
  "sub_data_engineering": "هندسة البيانات",
  "sub_decision_making": "اتخاذ القرار",
  "sub_design_systems": "أنظمة التصميم",
  "sub_devops_cloud": "DevOps والسحابة",
  "sub_energy": "الطاقة",
  "sub_financial_services": "الخدمات المالية",
  "sub_fintech": "التقنية المالية",
  "sub_frontend": "تطوير الواجهة الأمامية",
  "sub_fundraising_vc": "جمع التمويل ورأس المال الجريء",
  "sub_generative_ai": "الذكاء الاصطناعي التوليدي",
  "sub_go_to_market": "استراتيجية دخول السوق",
  "sub_government_public": "الحكومة والسياسات",
  "sub_growth_marketing": "تسويق النمو",
  "sub_healthcare_lifesciences": "الصحة وعلوم الحياة",
  "sub_industrial_manufacturing": "الصناعة والتصنيع",
  "sub_infrastructure_construction": "البنية التحتية والإنشاءات",
  "sub_insurance": "التأمين",
  "sub_investing_markets": "الاستثمار والأسواق",
  "sub_learning_development": "التعلّم والتطوير",
  "sub_machine_learning": "تعلّم الآلة",
  "sub_mlops": "MLOps",
  "sub_mobile_dev": "تطوير التطبيقات",
  "sub_networking": "بناء العلاقات",
  "sub_org_culture": "ثقافة الشركة",
  "sub_org_strategy": "التنظيم والاستراتيجية",
  "sub_people_management": "إدارة الفرق",
  "sub_performance_marketing": "التسويق بالأداء",
  "sub_personal_finance": "التمويل الشخصي",
  "sub_process_optimization": "تحسين العمليات",
  "sub_product_analytics": "تحليلات المنتج",
  "sub_product_design": "تصميم المنتج",
  "sub_product_discovery": "اكتشاف المنتج والبحث",
  "sub_product_led_growth": "النمو بقيادة المنتج",
  "sub_product_strategy": "استراتيجية المنتج",
  "sub_productivity": "الإنتاجية",
  "sub_project_management": "إدارة المشاريع",
  "sub_remote_teams": "الفرق عن بُعد والهجينة",
  "sub_roadmapping": "خارطة الطريق والأولويات",
  "sub_sales_ops": "عمليات المبيعات",
  "sub_security": "الأمن",
  "sub_seo_sem": "تحسين محركات البحث",
  "sub_social_media_marketing": "التسويق عبر وسائل التواصل",
  "sub_solopreneurship": "ريادة الأعمال الفردية",
  "sub_startup_building": "بناء الشركات الناشئة",
  "sub_supply_chain": "سلسلة التوريد",
  "sub_talent_acquisition": "استقطاب المواهب",
  "sub_tech_media_telecom": "التقنية والإعلام والاتصالات",
  "sub_transport_logistics": "النقل واللوجستيات",
  "sub_ui_design": "تصميم الواجهات",
  "sub_ux_research": "أبحاث تجربة المستخدم",
  "sub_wellbeing": "التوازن بين العمل والحياة",
  "cat_business": "أعمال",
  "cat_finance": "مالية",
  "cat_data_ai": "بيانات وذكاء اصطناعي",
  "cat_leadership": "قيادة",
  "cat_growth": "تطوير مهني",
  "cat_design": "تصميم وتجربة مستخدم",
  "cat_people": "أشخاص وثقافة",
  "cat_entrepreneurship": "ريادة أعمال",
  "cat_operations": "عمليات",
  "cat_engineering": "برمجيات وهندسة",
  "cat_marketing": "تسويق",
  "cat_product": "إدارة منتج",
  "cat_sales": "مبيعات وتنمية أعمال",
  "cat_empty_title": "لا يوجد محتوى في هذا الموضوع بعد"
 }
}